import type {DataRouterEditBlobPagePayload} from '@github-ui/code-view-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {SerializableQueryDeps} from '@github-ui/react-core/future/data-router-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewNewRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewNewRoute', {
  path: '/:owner/:repo/new/:branch/*',
  queries: [
    mainQuery<DataRouterEditBlobPagePayload>({
      queryDeps: ({pathname, searchParams}) => {
        if (isFeatureEnabled('react_data_router_serializable_query_deps')) {
          return {pathname, searchParams: Object.fromEntries(searchParams)}
        }
        // TODO(react_data_router_serializable_query_deps): remove cast and legacy branch when flag is at 100%.
        return {pathname, searchParams} as unknown as SerializableQueryDeps & {pathname: string}
      },
      encodeFetchPath: true,
    }),
  ],
})
